import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { stackItems, totalValue, formatARS } from '../data/offer';
export function ValueStack() {
  return <section id="incluye" className="border-b border-ink-800 bg-ink-950" data-id="element-123" data-mp="245rkc1sz1t4g">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-124" data-mp="1q9xmcdtqko64">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-flame-500" data-id="element-125" data-mp="1u96eje94odzk">
          Lo que te llevás hoy
        </p>
        <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-126" data-mp="2i02bepsfxzdo">
          El paquete completo
        </h2>

        <ul className="mt-10 divide-y divide-ink-800 overflow-hidden rounded-xl border border-ink-700 bg-ink-900" data-id="element-127" data-mp="297qpnh89v041">
          {stackItems.map(item => <li key={item.title} className="flex flex-col gap-3 p-5 sm:flex-row sm:items-start sm:justify-between sm:gap-6" data-id="element-128" data-mp="2d6zf49wa4bts">
              <div className="flex items-start gap-4" data-id="element-129" data-mp="35q51j0csov9n">
                <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md ${item.bonus ? 'bg-volt/15' : 'bg-flame-500/15'}`} data-id="element-130" data-mp="1tfcwsy85xdw6">
                  {item.bonus ? <GiftIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-131" data-mp="236hazvq0kupy" /> : <CheckIcon className="h-4 w-4 text-flame-500" strokeWidth={3} aria-hidden="true" data-id="element-132" data-mp="1yd50epi66og7" />}
                </span>
                <div data-id="element-133" data-mp="2m40kf0gdwfcw">
                  <p className={`text-[11px] font-bold uppercase tracking-[0.18em] ${item.bonus ? 'text-volt' : 'text-flame-500'}`} data-id="element-134" data-mp="2m4af31cdjaox">
                    {item.label}
                  </p>
                  <h3 className="mt-1 font-display text-xl font-bold uppercase text-white" data-id="element-135" data-mp="mqwk1542c49l">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-zinc-400" data-id="element-136" data-mp="2muh8pnlzeyyf">
                    {item.description}
                  </p>
                </div>
              </div>
              <p className="shrink-0 pl-12 font-display text-lg font-bold tabular-nums text-zinc-500 line-through sm:pl-0 sm:text-right" data-id="element-137" data-mp="2vtksyuwvxkei">
                {formatARS(item.value)}
              </p>
            </li>)}
        </ul>

        <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-flame-500/40 bg-flame-500/10 px-6 py-5" data-id="element-138" data-mp="35ridp8fjcz2d">
          <p className="font-display text-xl font-extrabold uppercase tracking-wide text-white" data-id="element-139" data-mp="3fi3e91ersdnx">
            Valor total
          </p>
          <p className="font-display text-3xl font-extrabold tabular-nums text-flame-400 line-through" data-id="element-140" data-mp="3ji53uc78dgmu">
            {formatARS(totalValue)} ARS
          </p>
        </div>
      </div>
    </section>;
}